export enum ExportTypesNamesEnum {
  RawDataFile = 'Raw Data File',
  RawDataFileDetailed = 'Raw Data File (Detailed)',
  RawDataAggregated = 'Raw Data File (Aggregated with D2L Data)',
}
